<ng-container *ngIf="user$ | async as user">
  <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="16px">
    <div class="flex basis-1/2 flex-col gap-8" [formGroup]="form">
      <div class="flex flex-col">
        <h1 class="mat-headline-4 !mb-4">Edit User</h1>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mobile Number</mat-label>
          <input matInput formControlName="phone" />
        </mat-form-field>

        <mat-slide-toggle
          *ngIf="(isLoggedInUser$ | async) === false"
          formControlName="isEnabled"
        >
          Is Enabled
        </mat-slide-toggle>
      </div>

      @if (showAccess && (canConfigureAuth$ | async)) {
        <div class="mb-4 flex flex-col">
          <h1 class="mat-headline-4 !mb-4">Security</h1>
          <mat-form-field floatLabel="always">
            <mat-label>Two-factor authentication</mat-label>
            <mat-select
              formControlName="multifactorOverride"
              appearance="outline"
            >
              <mat-option value="inherit">Use workspace setting</mat-option>
              <mat-option value="required">Required</mat-option>
              <mat-option value="disabled">Disabled</mat-option>
            </mat-select>
            <mat-hint>
              When two-factor authentication changes from 'Required' to
              'Disabled' for this user, all verification methods will be
              permanently removed from their account.
            </mat-hint>
          </mat-form-field>
        </div>
      }

      @if (showRoles) {
        <div class="flex flex-col">
          <h1 class="mat-headline-4 !mb-4">Roles</h1>
          <pr-role-assignment
            [options]="roles$ | async"
            [roles]="user.roles"
            [disabled]="disabled$ | async"
            (rolesChange)="updateRoles($event)"
          />
        </div>
      }

      @if (showAccess) {
        <div class="flex flex-col">
          <h1 class="mat-headline-4 !mb-4">Access</h1>
          <pr-access-selector
            [brands]="brands$ | async"
            [access]="user"
            [disabled]="disabled$ | async"
            (accessChange)="updateAccess($event)"
          />
        </div>
      }
    </div>

    <pt-profile-image-manager
      [storagePath]="organisation.storagePath$ | async"
      [profile]="user"
    />
  </div>
  <pt-buttons-container padding="all-round">
    <button
      *ngIf="canInvite(user)"
      mat-stroked-button
      (click)="inviteUser.emit(user)"
    >
      Resend Invitation
    </button>
    <pt-loader-button
      color="primary"
      type="flat"
      [disabled]="form.invalid"
      [loading]="saving$ | async"
      (clicked)="save()"
    >
      Save
    </pt-loader-button>
  </pt-buttons-container>
</ng-container>
